module.exports = __webpack_public_path__ + "img/el tesoro del saber.cb05a47b.svg";